import React, { Component } from 'react';
import { translate } from 'react-polyglot';
import classNames from 'classnames';
import BookCard from '../BookCard';
import Checkbox from '../Checkbox';
import Button from '../Button';
import Grid from '../Grid';
import { gaReadSource } from '../../lib/constants';
import './OfflineThemeCard.scss';



@translate()

class OfflineThemeCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isButtonClicked: false,
    }
  }

  onToggleButton = () => {
    this.setState({ isButtonClicked: !this.state.isButtonClicked })
  }

  renderBookEls = (books) => {
    const { online , viewport } = this.props;
    return books.map(book => {
      return (
        <BookCard
          key={book.id}
          id={book.id}
          book={book}
          shouldDisplayMenu={true}
          customMenu={true}
          hideQuickViewBtn={true}
          hideDeleteOfflineRpIcon={!viewport.medium}
          shouldShowReadIcon={true}
          noSrcSet={!online}
          hideReadCountStat={true}
          readSource={gaReadSource.offlineLibrary}
          isRtl={this.props.isRtlLocale}
          isOfflineRp={true}
          eventLabel={'rp'}
          eventCategory={gaReadSource.offlineLibrary}
        />
      );
    });
  }

  render() {
    const baseClassName = 'pb-offline-theme-card';
    const {
      t,
      themeBooks,
      editActive,
      fluencyId,
      onChange,
      viewport,
      themeCheckedValues,
      isRtl,
      isRtlLocale
    } = this.props;


    const classes = {
      [baseClassName]: true,
      [`${baseClassName}--edit-active`]: editActive,
      [`${baseClassName}--edit-active-checked`]: themeBooks && themeBooks.length > 0 ? themeCheckedValues.includes(themeBooks[0].themeName.concat(fluencyId)) : null,
      [`${baseClassName}--is-button-clicked`]: this.state.isButtonClicked && !editActive,
      [`${baseClassName}--rtl`]: isRtl,
    };

    return (
      themeBooks && themeBooks.length > 0 &&
      <div className={classNames(classes)}>
        <div className={`${baseClassName}__theme-wrapper`}>
          <div className={`${baseClassName}__theme-image-wrapper`}>
            <img className={`${baseClassName}__theme-image`} src={ viewport.medium ? themeBooks[0].themeImage : themeBooks[0].themeMobileImage} alt="banner Storyweaver" />
             <div className={`${baseClassName}__theme-image-overlay`}></div>
          </div>
          <div className={`${baseClassName}__theme-text-wrapper`}>
            <div className={`${baseClassName}__theme-count-wrapper`}>
              <div className={`${baseClassName}__theme-number`}>
              <span> {t('global.offline-theme-book-count', { themeNumber: themeBooks[0].themeNumber }).toLowerCase()}
              </span>
              <span className={`${baseClassName}__theme-book-count ${isRtlLocale ? `${baseClassName}__theme-book-count--rtl` : ""}`}> {t("global.reading-program-theme-card-text").toLowerCase()}
              </span></div>
              {
                editActive ?
                  <div className={`${baseClassName}__checkbox-wrapper`}>
                    <Checkbox
                      id={themeBooks[0].themeName}
                      activeIcon={"active"}
                      inactiveIcon={"inactive"}
                      value={themeBooks[0].themeName.concat(fluencyId)}
                      inline
                      onChange={onChange}
                      checked={themeCheckedValues.includes(themeBooks[0].themeName.concat(fluencyId))}
                      theme="white"
                      themeLabel="white"
                      themeCardLabel
                    /></div>
                  :
                  null
              }
            </div>
            <div className={`${baseClassName}__theme-title`}>{themeBooks[0].themeName}</div>
            <div className={`${baseClassName}__theme-text`}>{themeBooks[0].themeDescription.length > 100 && viewport.medium ? themeBooks[0].themeDescription.substring(0, 100) + '...' : themeBooks[0].themeDescription }</div>
            <p className={`${baseClassName}__theme-tip`}><span><b>{t("global.tip")}:</b> </span><span> {themeBooks[0].themeTip.length > 100 && viewport.medium ? themeBooks[0].themeTip.substring(0, 100) + '...' : themeBooks[0].themeTip}</span></p>
            <Button 
              iconRight={"down-arrow"}
              label={t("global.view-books").toLowerCase()}
              parentClassName={!this.state.isButtonClicked || editActive ? `${baseClassName}__theme-toggle-button` : `${baseClassName}__theme-toggle-button ${baseClassName}__theme-toggle-button--reverse`}
              onClick={this.onToggleButton}
              rounded
              noIconTitle
              isRtl={isRtl}
            />
          </div>
        </div>
        <div className={`${baseClassName}__theme-book-grid`}>
          {
            this.state.isButtonClicked && !editActive
              ?
              <Grid variant="2up-6up" isRtl={isRtl}>
                {this.renderBookEls(themeBooks)}
              </Grid>
              : null
          }
        </div>
      </div>
    )
  }
}

export default OfflineThemeCard;


// WEBPACK FOOTER //
// ./src/components/OfflineThemeCard/OfflineThemeCard.jsx